const TICK_MS = 1000;

/**
 * 만료 시각까지 1초마다 지금 시각을 알린다.
 *
 * 시작할 때 한 번 알린다. 만료 시각이 지나면 한 번 더 알리고 타이머를 지운다. 만료한 뒤에는 화면이
 * 다시 그릴 것이 없다. 반환한 함수는 타이머를 멈춘다.
 */
export function startExpiryTicks(expiresAtMs: number, onTick: (nowMs: number) => void): () => void {
  const startedAtMs = Date.now();
  onTick(startedAtMs);
  if (startedAtMs >= expiresAtMs) {
    return () => undefined;
  }

  const timer = setInterval(() => {
    const nowMs = Date.now();
    if (nowMs >= expiresAtMs) {
      clearInterval(timer);
    }
    onTick(nowMs);
  }, TICK_MS);
  return () => clearInterval(timer);
}
